import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from 'providers/AppProvider';

const usePasswordToggle = (): [string, JSX.Element] => {
  const [visible, setVisiblity] = useState(false);
  const {
    config: { theme }
  } = useAppContext();

  const Icon = (
    <FontAwesomeIcon
      icon={visible ? faEyeSlash : faEye}
      onClick={() => setVisiblity(visibility => !visibility)}
      style={{ color: `${theme === 'dark' ? '#fff' : '#000'}` }}
    />
  );

  const InputType = visible ? 'text' : 'password';

  return [InputType, Icon];
};

export default usePasswordToggle;
